export default "__VITE_ASSET__e943dc26__"